import { useEffect, useRef, useState } from "react";
import { Box, Button } from "@mui/material";
import dayjs from "dayjs";

const DateSelect = ({ date, setDate, disabled = false }) => {
    const [dateChipData, setDateChipData] = useState([]);
    const scrollRef = useRef(null);
    const selectedDateRef = useRef(null);

    const getNextDays = (startDate, days) => {
        return Array.from({ length: days }, (_, i) => {
            const next = new Date(startDate);
            next.setDate(startDate.getDate() + i + 1);
            return next;
        });
    };
    const getPastDays = (startDate, days) => {
        return Array.from({ length: days }, (_, i) => {
            const past = new Date(startDate);
            past.setDate(startDate.getDate() - i - 1);
            return past;
        });
    };

    useEffect(() => {
        const newDates = [...getPastDays(date, 7).reverse(), date, ...getNextDays(date, 7)];
        setDateChipData(newDates);
    }, [date]);

    useEffect(() => {
        if (selectedDateRef.current && scrollRef.current) {
            const rect = selectedDateRef.current.getBoundingClientRect();
            const parentRect = scrollRef.current.getBoundingClientRect();
            let newScrollLeft;

            if (date.getTime() > new Date().getTime()) {
                // Scroll to the right for centering the element if the date is greater
                newScrollLeft = rect.right - parentRect.right + scrollRef.current.scrollLeft;
            } else {
                // Center the element
                newScrollLeft = rect.left + rect.width / 2 - parentRect.width / 2 + scrollRef.current.scrollLeft;
            }

            // Scroll smoothly to the new scrollLeft position
            scrollRef.current.scrollTo({ left: newScrollLeft, behavior: "smooth" });
        }
    }, [dateChipData, date]);

    const onDateClick = (newDate) => {
        if (!disabled) {
            setDate(newDate);
        }
    };

    return (
        <Box
            ref={scrollRef}
            sx={{
                display: "flex",
                WebkitOverflowScrolling: "touch",
                overflowX: "auto",
                whiteSpace: "nowrap",
                gap: "0.3rem",
                opacity: disabled ? 0.5 : 1,
                pointerEvents: disabled ? "none" : "auto",
            }}
        >
            {dateChipData.map((dateItem, index) => {
                const isSelected = dateItem.getTime() === date.getTime();
                return (
                    <Button
                        key={index}
                        ref={isSelected ? selectedDateRef : null}
                        onClick={() => onDateClick(dateItem)}
                        variant={isSelected ? "contained" : "outlined"}
                        sx={{
                            borderRadius: 50,
                            ...(isSelected && {
                                color: "#fff",
                                backgroundColor: "#000",
                            }),
                        }}
                        size="small"
                        disabled={disabled}
                    >
                        {dayjs(dateItem).format("DD.MM.YY")}
                    </Button>
                );
            })}
        </Box>
    );
};

export default DateSelect;
